import { Quote } from 'slices/quote';
import { Instalment, Payment, PolicyResponse } from 'types/policy';

import { Nullable } from '../../../types/utils';

const getPremiums = (state: PolicyResponse | null) => {
  if (!state) return {};
  return state.policy?.policyPremium?.transactionPremium?.totalPremium;
};

const getInstalment = (payments: Payment) => {
  const { instalments } = payments;
  if (!instalments) return false;

  // Accumulate all the instalments premium
  const totalInstalments = instalments.reduce(
    (sum: number, instalment: Instalment) => sum + Number(instalment.instalmentPremium),
    0
  );
  // Calculate the average amount.
  return (totalInstalments / 12).toFixed(2);
};

const getQuote = (state: Nullable<Quote>) => {
  if (!state) return {};
  let quoteDataPoints = {};
  const premium = getPremiums(state.premiums);
  const { quoteNumber, policyNumber } = state;

  const { paymentSchedule, levelOfExcess } = state;

  quoteDataPoints = {
    ...quoteDataPoints,
    totalAnnualPremium: premium,
    quoteTerms: paymentSchedule,
    excess: levelOfExcess,
    quoteNumber,
    policyNumber,
  };

  if (state?.premiums?.policy?.payment)
    quoteDataPoints = {
      monthlyPremium: getInstalment(state.premiums.policy.payment),
      ...quoteDataPoints,
    };

  return quoteDataPoints;
};

export default getQuote;
